export default {
    currentModule: {}
}